import { WorkspaceFCOContainer } from '../../../core/types/fcoTypes';

import { useGetFcos } from '../../../api/fcos';
import { useUserSettings } from '../../context/UserSettingsContext';

// @tecton
import { Empty, Loading, ViewLayout } from '@lithos';
import { TECTON_DOCUMENTATION_LINKS } from '../application-links';
import TransformationsList from './TransformationsList';

export const TransformationsContainer = () => {
  const { workspace } = useUserSettings();

  const { data, isLoading, isError } = useGetFcos<WorkspaceFCOContainer>(workspace as string, {
    select: (data: WorkspaceFCOContainer) => {
      return {
        transformations: data.transformations,
        idToFcoMap: data.idToFcoMap,
      };
    },
  });

  const headerProps = {
    breadcrumbs: {
      root: { label: workspace ?? '', url: `/repo/${workspace}` },
      items: [{ label: 'Transformations' }],
    },
    title: 'Transformations',
    subtitle: 'Transformations define the logic for transforming raw data to features.',
    learnMoreLink: TECTON_DOCUMENTATION_LINKS.TRANSFORMATIONS,
  };

  if (isLoading) {
    return <ViewLayout header={headerProps} content={<Loading />} />;
  }

  if (isError) {
    return (
      <ViewLayout
        header={headerProps}
        content={
          <Empty
            description="There was an error loading Transformations for this workspace. Please try again."
            placement="full-page"
            useCase="errorUnknown"
            actions={undefined}
            title={<>Error loading Transformations</>}
          />
        }
      />
    );
  }
  return (
    <ViewLayout
      header={headerProps}
      content={
        <TransformationsList
          items={data?.transformations ?? []}
          idToFcoMap={data?.idToFcoMap ?? {}}
          workspace={workspace ?? ''}
        />
      }
    />
  );
};

export default TransformationsContainer;
